import { useTheme } from '../../hooks/useTheme';

import { NAV_THEMES } from './nav-tokens';
import NavPanelEntries from './NavPanelEntries';
import type { NavModel } from './use-nav-model';
import type { NavFlyoutApi } from './useNavFlyout';

interface NavPanelSectionsProps {
  nav: NavModel;
  flyout: NavFlyoutApi;
  flyoutId: string;
}

/** The labelled panel's destination list, under its heading. */
export default function NavPanelSections({ nav, flyout, flyoutId }: NavPanelSectionsProps) {
  const { theme } = useTheme();
  const t = NAV_THEMES[theme];

  return (
    <nav aria-label="Sections" className="flex flex-col">
      <div
        className="px-3 pb-1 text-[11px] font-bold uppercase tracking-wider"
        style={{ color: t.muted }}
      >
        Go to
      </div>
      <NavPanelEntries nav={nav} flyout={flyout} flyoutId={flyoutId} collapsed={false} />
    </nav>
  );
}
